import axios from 'axios';
import {logoutUserAction} from '../store/actions/authActions';
let host;
// console.log("ENV", process.env.REACT_APP_MODE);
if(process.env.NODE_ENV == "development"){
    // Set development api url
    host = "http://localhost:8080/api/";
    //host = "https://api.99point9.ca/api/";
}else if(process.env.REACT_APP_MODE == "staging"){
    host = "http://99api.nickgermaine.com/api/";
}else{
    host = "https://api.99point9.ca/api/";
    //host = "https://99api.nickgermaine.com/api/";
}

const api = {
    makeVideoURL: (uri) => {
        if(process.env.NODE_ENV == "development"){
            return 'https://s3.amazonaws.com/99storage/' + uri
        }else{
            return 'https://d189wr37i6dtm4.cloudfront.net/' + uri
            // Staging:
            //return 'https://s3.amazonaws.com/99storage/' + uri
        }
    },
    makeFileURL: (uri, token) => {
        return host.replace('/api/', '') + uri + `?access_token=${token}`
    },
    getSettings: (success) => {
        axios.get(`${host}Settings`)
        .then(res => {
            success(res);
        })
    },
    getCoursesByToken: (token, success) => {
        axios.get(`${host}Courses/getCoursesByToken?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    RegisterUser: (data, success) => {
        axios.post(`${host}users`, data)
            .then(res => {
                success(res)
            })
            .catch(error => {
                success(error)
            });

    },
    getChatLectures: (subjectId, token, success) => {
        axios.get(`${host}CourseSubjects/${subjectId}?access_token=${token}`, {
            params: {
                filter: {
                    include: {
                        relation: "CourseChapter",
                        scope: {

                            order: "number ASC",
                            include: {
                                relation: "ChapterVideo",
                                scope: {
                                    where: {
                                        or: [
                                            {status: true},
                                            {status: "Active"}
                                        ]
                                    },
                                    order: 'number ASC'
                                }
                            }
                        }
                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getULVideoQuestions: (lectureId, token, success) => {
        axios.get(`${host}UserLectures/${lectureId}/VideoQuestions?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getQuizResults: (lectureId, token, success) => {
        axios.get(`${host}UserLectures/${lectureId}/Quiz?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    deleteUser: (id, token, success) => {
        axios.post(`${host}users/delete?access_token=${token}`, {id: id})
        .then(res => {
            success(res);
        })
    },
    sendToken: (user, token, success) => {
        axios.post(`${host}Emails/sendVerifyToken`, {email: user.email})
            .then(res => {
                success(res);
            });
    },
    sendAllTokens: (token, success) => {
        axios.post(`${host}Emails/sendAllVerifyToken?access_token=${token}`)
            .then(res => {
                success(res);
            });
    },
    getOrMakeQuiz: (userLectureId, token, success) => {
        axios.post(`${host}ChapterTests/getOrMake?access_token=${token}`, {userLectureId: userLectureId})
            .then(res => {
                success(res);
            })
    },
    addUserQuizQuestion: (quizId, question, mode, token, success) => {
        axios.post(`${host}ChapterTests/addQuestion?access_token=${token}`, {quizId: quizId, question: question, mode: mode})
            .then(res => {
                success(res);
            })
    },
    updateCurrentQuestion: (quizId, mode, t, token, success) => {
        axios.post(`${host}ChapterTests/updateCurrentQuestion?access_token=${token}`, {quizId, mode, time: t})
            .then(res => {
                success(res);
            })
    },
    updateComment: (comment, token, success) => {
        axios.post(`${host}Courses/updateComment?access_token=${token}`, {comment: comment})
            .then (res => {
                success(res);
            })
    },
    getComments: (skip, courseId, token, success) => {
      axios.get(`${host}Courses/getComments?access_token=${token}`, {params: {skip, courseId}})
          .then(res => {
              success(res);
          })
    },
    verifyCode: (user, code, email, success) => {
        axios.post(`${host}Emails/verifyToken`, {user: {email: email, code: code}})
            .then(res => {
                success(res);
            });
    },
    getProfile: (profileId, token, success) => {
        axios.get(`${host}Profiles/${profileId}?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: {"CourseUser": ["UserTest", {"Course": {"CourseSubject": {"CourseChapter": {"ChapterVideo": ["ChapterPartImage", "ChapterPartBanner"]}}}}]}
            })
        }})
            .then(res => {
                success(res);
            })
    },
    getChatThreads: (profileId, token, success) => {
        axios.get(`${host}Threads/?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: "Messages",
                where:
                                {
                                    users: {
                                        inq: profileId
                                    }
                                }
            })
        }})
            .then(res => {
                success(res);
            })
    },
    loadSlimCourse: (courseId, token, success) => {
        axios.get(`${host}Courses/${courseId}/CourseVideo?access_token=${token}`, {params: {
                filter: JSON.stringify({
                    fields: {title: true, id: true}
                    
            })
            
        }}).then(res => {
                success(res);
            })  
    },
    getProfiles: (token, success) => {
        axios.get(`${host}Profiles?access_token=${token}`, {params: {
            filter: JSON.stringify({
                scope: {fields: {
                    name: true,
                    role: true,
                    lname: true,
                    online: true,
                    email: true,
                    image: true
                }}
            })
        }})
        .then(res => {
            success(res);
        })
    },
    GetLogins: (user, token, success) => {
      axios.get(`${host}users/${user.id}/logins?access_token=${token}`, {params:
          {
              filter: JSON.stringify({
                  order: 'created DESC'
              })
          }
      })
          .then(res => {
              success(res);
          })
    },
    LoginUser: (data, success) => {
        axios.post(`${host}users/login?include=User`, data)
            .then(res => {

                axios.get(`${host}users/${res.data.userId}?access_token=${res.data.id}`, {params:
                    {filter: JSON.stringify({
                        include:
                            {"Profile": {"CourseUser": {"Course": "CourseSubject"}}}

                    })}})
                    .then(res2 => {
                        res.data.user.Profile = res2.data.Profile;
                        success(res);

                    })

            })
            .catch(error => {
                success(error)
            });
    },

    resetPassword: (data, success) => {
        axios.post(`${host}Emails/sendPasswordEmail`, data)
            .then(res => {
                success(res);
            });
    },
    resetPasswordWithToken: (data, success) => {
        let token = data.access_token;
        axios.post(`${host}Emails/resetPassword`, {token: token, password: data.password})
            .then(res => {
                success(res);
            });
    },
    updateProfile: (data, token, success) => {
        axios.patch(`${host}Profiles/${data.id}?access_token=${token}`, data, {params: {
            filter: JSON.stringify({
                include: {"CourseUser": ["UserTest", "Course"]}
            })
        }})
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },
    updateUser: (token, data, success) => {
        axios.patch(`${host}users/${data.id}?access_token=${token}`, data)
            .then(res => {
                success(res);
            })
    },
    getAllCourses: success => {
      axios.get(`${host}Courses`)
          .then(res => {
              success(res);
          })
    },
    addCourse: (data, token, success) => {
        let d = {
            course: data,
            userId: ''
        };

        axios.post(`${host}Courses/addCourse?access_token=${token}`, d)
            .then(res => {
                success(res);
            })
    },
    courseUserNextStep: (courseUser, token, success) => {
        axios.post(`${host}CourseUsers/nextStep/?access_token=${token}`, {cuo: courseUser}, {params: {
            filter: JSON.stringify({
                include: ["UserTest", "Course"]
            })
        }})
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    updateCourseUser: (courseUser, token, success) => {
        courseUser.lastActive = new Date();
        if(courseUser.activity){
            courseUser.activity.concat(new Date());
        }else{
            courseUser.activity = [new Date()];
        }

        axios.patch(`${host}CourseUsers/${courseUser.id}?access_token=${token}`, courseUser, {params: {
            filter: JSON.stringify({
                include: ["UserTest", "Course"]
            })
        }})
            .then(res => {
                success(res);
            })
    },
    getCoursesById: (userId, courseIds, token, success) => {
        axios.get(`${host}Courses?access_token=${token}`, {
            params: {
                filter:
                    JSON.stringify(
                        {
                            include: ["DiagnosticTest", "ChapterTestTemplate", {"CourseUser": "Profile"}, {'CourseSubject': {
                                relation: 'CourseChapter',
                                scope: {
                                    order: 'number ASC',
                                    include: {
                                        relation: 'ChapterVideo',
                                        scope: {
                                            order: 'number ASC',
                                            include: ["ChapterPartImage", "VideoFile", "ChapterPartBanner", "ChapterTest", "VideoQuestions",  {
                                                relation: 'QuizQuestions',
                                                scope: {
                                                order: 'number ASC',
                                                include: 'File'
                                                }}]
                                        }
                                    }
                                }
        
                            }}],
                            where:
                                {
                                    id: {
                                        inq: courseIds
                                    }
                                }

                        })
            }
        })
            .then(res => {
                success(res);
            });
    },

    getUsers: (token, skip, success) => {
        axios.get(`${host}users/get?access_token=${token}`, {params: {skip: skip}}).then(res => {
            success(res);
        })
    },
    findUsers: (where, token, skip, success) => {
        axios.get(`${host}users/search?access_token=${token}`, {params: {
            where: where,
            skip: skip,
        }}).then(res => {
            success(res);
        })
    },
    getCompletedUserLectures: (usid, token, success) => {
        axios.get(`${host}UserSubjects/${usid}/UserLectures?access_token=${token}`, {
            params: {
                filter: {
                    limit: 0
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getConsoleStudents: (courseIds, skip, limit, filter, userId, token, success) => {
        axios.get(`${host}Courses/getConsoleStudents?access_token=${token}`, {
            params: {
                courseIds: courseIds,
                f: filter,
                userId: userId,
                skip: skip,
                limit: limit,
            }
        }).then(res => {
            success(res);
        })
    },
    saveSearchStudent: (cuId, fields, token, success) => {
        let data = {
            id: cuId,
            fields: fields,
            access_token: token
        }
        axios.post(`${host}CourseUsers/saveSearchStudent?access_token=${token}`, data)
            .then(res => {
                success(res);
            })
    },
    searchStudents: (data, userId, token, success) => {
        let apiData = {
            clientQuery: data,
            access_token: token,
            headers: {
                'Authorization': `${token}`
            }
        }
        data.access_token = token;
        axios.post(`${host}CourseUsers/search?access_token=${token}`, apiData)
            .then(res => {
                success(res);
            })
    },
    getConsoleInstructors: (courseIds, token, success) => {
        axios.get(`${host}CourseUsers/?access_token=${token}`, {
            params: {
                filter: {
                    where: {courseId: {inq: courseIds}, role: 'instructor'},
                    fields: {
                        avatar: true,
                        id: true,
                        profileId: true,
                        quizPercent: true,
                        attentivePercent: true,
                        completionPercent: true,
                        points: true,
                        pname: true,
                        course: true,
                        email: true,
                    },
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getLeaderboard: (courseIds, skip, limit, token, success) => {
        const where = {};
        if (courseIds) {
            where.courseId = {inq: courseIds};
            where.role = 'student';
        }
        axios.get(`${host}CourseUsers?access_token=${token}`, {
            params: {
                filter: {
                    where: where,
                    fields: {
                        avatar: true,
                        id: true,
                        profileId: true,
                        quizPercent: true,
                        attentivePercent: true,
                        completionPercent: true,
                        points: true,
                        pname: true,
                        pos: true,
                        globalPos: true,
                    },
                    order: 'globalPos ASC',
                    skip: skip,
                    limit: limit

                }
            }
        }).then(res => {
            success(res);
        })
    },
    getKpiStats: (courseId, token, success) => {
      axios.get(`${host}Courses/getKpiStats?access_token=${token}`, {params: {courseId: courseId}})
          .then(res => {
              success(res);
          })
    },
    getAdminFlags: (id, token, success) => {
        axios.get(`${host}Flags/?access_token=${token}`, {params: {
            filter: {
                where: {courseUserId: id}
            }
        }}).then(res => {
            success(res);
        })
    },
    getEngagementStat: (name, courseId, token, success) => {
        axios.get(`${host}Stats/getEngagementStat?access_token=${token}`, {params: {name: name, courseId: courseId}})
            .then(res => {
                success(res);
            })
    },
    getEngagementPage: (courseId, userId, token, success) => {
        axios.get(`${host}AdminPages/findOne?access_token=${token}`, {params: {
            filter: {
                where: courseId ? {title: 'engagement', courseId: courseId} : {title: 'engagement', userId: userId}
            }
        }}).then(res => {
            success(res);
        })
    },
    getEngagementChart: (view, length, courseId, userId, token, success) => {
        axios.get(`${host}Courses/getEngagementChart?access_token=${token}`, {
            params: {
                view: view,
                length: length,
                courseId: courseId,
                userId: userId
            }
        }).then(res => {
            success(res);
        })
    },
    getUserSubject: (subId, cu, token, success) => {
        axios.get(`${host}UserSubjects/?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    where: {
                        courseSubjectId: subId,
                        courseUserId: cu.id,
                        courseAttempt: cu.courseAttempt,
                        active: true
                    },
                    include: {Subject: {
                        relation: "CourseChapter",
                        scope: {

                            order: "number ASC",
                            
                        }
                    }}
                    
                })
            }
        }).then(res => {

            success(res);
        })
    },
    getUserSubjectContent: (chapterId, cu, token, success) => {
        axios.get(`${host}SubjectChapters/${chapterId}?access_token=${token}`, {params: {
            filter: {
                fields: {
                    id: true
                },
                include: ["File", {
                    relation: "ChapterVideo",
                    scope: {
                        where: {
                            or: [
                                {status: true},
                                {status: "Active"}
                            ]
                        },
                        order: 'number ASC',
                        include: ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions", "VideoFile",  {
                            relation: 'UserLecture',
                            scope: {
                                where: {
                                    courseUserId: cu.id,
                                    subjectAttempt: cu.subjectAttempt,
                                    courseAttempt: cu.courseAttempt,
                                    active: true
                                },
                                order: 'createdOn DESC',
                                limit: 1
                            }
                        }]
                    }
                }]
            }
        }}).then(res => {
            success(res);
        })
    },
    createUserSubject: (subId, cu, token, success) => {
        axios.post(`${host}UserSubjects/?access_token=${token}`, {
            courseSubjectId: subId,
            courseUserId: cu.id,
            created: new Date(),
            courseAttempt: cu.courseAttempt,
            active: true,
            completedPercent: 0
        }).then(res => {
            success(res);
        })
    },
    getUserSubjectOld: (subId, cu, token, success) => {
        axios.get(`${host}CourseSubjects/${subId}?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    include: {"CourseChapter": ["File", {"ChapterVideo": ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions", "VideoFile",  {
                        relation: 'UserLecture',
                        scope: {
                            where: {
                                courseUserId: cu.id,
                                subjectAttempt: cu.subjectAttempt,
                                courseAttempt: cu.courseAttempt,
                                active: true
                            }
                        }
                    }, {
                        relation: 'QuizQuestions',
                        scope: {
                        order: 'number ASC',
                        include: 'File'
                        }}]}]}
                })
            }
        }).then(res => {

            success(res);
        })
    },
    updateChapterTest: (test, token, success) => {
        axios.patch(`${host}ChapterVideos/${test.id}?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    addChapterTest: (test, token, success) => {
        axios.post(`${host}ChapterVideos/?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    updateChapterTestTemplate: (test, token, success) => {
        axios.patch(`${host}ChapterTestTemplates/${test.id}?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    addChapterTestTemplate: (test, token, success) => {
        axios.post(`${host}ChapterTestTemplates/?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    getDiagTemplates: (token, success) => {
        axios.get(`${host}DiagnosticTests/?access_token=${token}`, {
            params: {
                filter: {
                    where: {testLocation: 'diagnostic'},
                    include: 'Course'
                }
            }
        })
            .then(res => {
                success(res);
            })
    },
    getChapterTestTemplates: (token, success) => {
        axios.get(`${host}ChapterVideos/?access_token=${token}`, {
            params: {
                filter: {
                    where: {type: 'test'},
                    include: ['Course', 'Subject']
                }
            }
        })
            .then(res => {
                success(res);
            })
    },
    getChapterTest: (id, token, success) => {
        axios.get(`${host}ChapterVideos/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    getDiagnosticTest: (id, token, success) => {
        axios.get(`${host}DiagnosticTests/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },

    updateChapterStatus: (id, status, token, success) => {
        axios.patch(`${host}SubjectChapters/${id}?access_token=${token}`, {status: status})
            .then(res => {
                success(res);
            });
    },
    updateChapterPartStatus: (id, status, token, success) => {
        axios.patch(`${host}ChapterVideos/${id}?access_token=${token}`, {status: status})
            .then(res => {
                success(res);
            });
    },
    createLog: (log, token, success) => {
        axios.post(`${host}Logs?access_token=${token}`, log)
        .then(res => {
            success(res);
        })
    },
    updateLog: (log, token, success) => {
        axios.patch(`${host}Logs/${log.id}?access_token=${token}`, log)
        .then(res => {
            success(res);
        })
    },
    getLogs: (cu, range, token, success) => {
        axios.get(`${host}Logs?access_token=${token}`, {
            params: {
                filter: {
                    where: {
                        courseUserId: cu, 
                        and: [
                            {date: {lt: range.end}},
                            {date: {gte: range.begin}},
                        ]
                    },
                    order: 'date DESC',
                    include: ['Lecture', 'Chapter', 'Subject'],
                    
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getLeaderboardCount: (courseIds, token, success) => {
        axios.get(`${host}CourseUsers/count?access_token=${token}`, {
            params: {
                filter: {
                    where: {courseId: {inq: courseIds}, role: 'student'}
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminFlagCount: (token, success) => {
        axios.get(`${host}Flags/count?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getSortedLeaderboard: (courseIds, skip, sort, limit, token, success) => {
        const where = {};
        if (courseIds) {
            where.courseId = {inq: courseIds};
            where.role = 'student';
        }
        axios.get(`${host}CourseUsers?access_token=${token}`, {
            params: {
                filter: {
                    where: where,
                    order: (sort.desc) ? sort.id + ' DESC' : sort.id + ' ASC',
                    skip: skip,
                    limit: limit,
                    fields: {
                        avatar: true,
                        id: true,
                        profileId: true,
                        quizPercent: true,
                        attentivePercent: true,
                        completionPercent: true,
                        points: true,
                        pname: true,
                        pos: true,
                        globalPos: true,
                    },
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleFlagsSorted: (skip, sort, limit, token, success) => {
        axios.get(`${host}Flags?access_token=${token}`, {
            params: {
                filter: {
                    order: (sort.desc) ? sort.id + ' DESC' : sort.id + ' ASC',
                    include: {CourseUser: 'Course'},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleFlags: (skip, limit, token, success) => {
        axios.get(`${host}Flags?access_token=${token}`, {
            params: {
                filter: {
                    order: 'createdOn DESC',
                    include: {CourseUser: 'Course'},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminLectureCount: (token, success) => {
        axios.get(`${host}UserLectures/count?access_token=${token}`, {
            params: {
               
                    where: {active: false}
                
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleLecturesSorted: (skip, sort, limit, token, success) => {
        axios.get(`${host}UserLectures?access_token=${token}`, {
            params: {
                filter: {
                    order: (sort.desc) ? sort.id + ' DESC' : sort.id + ' ASC',
                    include: {CourseUser: 'Course'},
                    where: {active: false},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleLectures: (skip, limit, token, success) => {
        axios.get(`${host}UserLectures?access_token=${token}`, {
            params: {
                filter: {
                    order: 'createdOn DESC',
                    include: {CourseUser: 'Course'},
                    where: {active: false},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminSubjectCount: (token, success) => {
        axios.get(`${host}UserSubjects/count?access_token=${token}`, {
            params: {
               
                    where: {active: false}
                
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleSubjectsSorted: (skip, sort, limit, token, success) => {
        axios.get(`${host}UserSubjects?access_token=${token}`, {
            params: {
                filter: {
                    order: (sort.desc) ? sort.id + ' DESC' : sort.id + ' ASC',
                    include: {CourseUser: 'Course'},
                    where: {active: false},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleSubjects: (skip, limit, token, success) => {
        axios.get(`${host}UserSubjects?access_token=${token}`, {
            params: {
                filter: {
                    order: 'createdOn DESC',
                    include: {CourseUser: 'Course'},
                    where: {active: false},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getAdminTestCount: (token, success) => {
        axios.get(`${host}CourseUsers/count?access_token=${token}`, {
            params: {
                where: {testDate: {exists: true}}
            }
        })
        .then(res => {
            success(res);
        })
    },
    getUserCount: (token, success) => {
        axios.get(`${host}CourseUsers/count?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getSessionCount: (token, success) => {
        axios.get(`${host}Logins/count?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getMessageCount: (token, success) => {
        axios.get(`${host}Messages/count?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getVideoTimeCount: (courseId, token, success) => {
        axios.get(`${host}Courses/videoTimeCount?access_token=${token}&courseId=${courseId}`)
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleTestsSorted: (skip, sort, limit, token, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {
            params: {
                filter: {
                    order: (sort.desc) ? sort.id + ' DESC' : sort.id + ' ASC',
                    where: {testDate: {exists: true}},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getKPIChart: (view, courseId, length, token, success) => {
        axios.get(`${host}Courses/buildKPIChart?view=${view}&courseId=${courseId}&length=${length}&access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getCountryChart: (length, token, success) => {
        axios.get(`${host}Courses/buildCountryChart?length=${length}&access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getAdminConsoleTests: (skip, limit, token, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {
            params: {
                filter: {
                    order: 'createdOn DESC',
                    where: {testDate: {exists: true}},
                    skip: skip,
                    limit: limit
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getFlags: (cu, token, success) => {
        axios.get(`${host}Flags?access_token=${token}`, {
            params: {
                filter: {
                    order: 'createdOn DESC',
                    where: {courseUserId: cu.id}
                }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getCourseUserFlags: (cu, token, success) => {
        axios.get(`${host}CourseUsers/${cu}/flags?access_token=${token}`, {params: {
            filter: {
                order: 'createdOn DESC'
            }
            }
        })
        .then(res => {
            success(res);
        })
    },
    getCompletedSubjects: (cuid, token, success) => {
        axios.get(`${host}CourseUsers/${cuid}/UserSubject?access_token=${token}`, {
            params: {
                filter: {
                    where: {
                        active: true
                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getCourseAndSubjects: (courseId, token, success) => {
        axios.get(`${host}Courses/${courseId}?access_token=${token}`, {
            params: {
                filter: {
                    include: 'CourseSubject'
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getUserLectureTests: (courseUserId, token, success) => {
        axios.get(`${host}UserLectures?access_token=${token}`, {
            params: {
                filter: {
                    where: {courseUserId: courseUserId},
                    fields: {
                        id: true,
                        correctPercent: true,
                        active: true,
                        completed: true,
                        chapterVideoId: true,
                        efficiency: true,
                        quiz: true,
                        completedIn: true,
                        testMode: true,
                        passed: true,
                        type: true,
                    },
                    limit: 999
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getSyllabus: (cuId, success) => {
        axios.get(`${host}CourseUsers/getSyllabus?courseUserId=${cuId}`).then(res => {
            success(res);
        })
    },
    enrichTest: (id, token, success) => {
        axios.get(`${host}UserLectures/${id}?access_token=${token}`).then(res => {
            success(res);
        })
    },
    enrichQuiz: (id, token, success) => {
        axios.get(`${host}ChapterTests/?access_token=${token}`, {
            params: {
                filter: {
                    where: {
                        userLectureId: id
                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getAllTests: (courseId, token, success) => {
        axios.get(`${host}ChapterVideos?access_token=${token}`, {params: {
            filter: {
                where: {
                    type: 'test'
                }
            }
        }}).then(res => {
            success(res);
        })
    },
    getTestCourseAndLectures: (courseId, token, success) => {
        axios.get(`${host}Courses/getTestsAndQuizzes?courseId=${courseId}&access_token=${token}`)
        .then(res => {
            success(res);
        });
    },
    getChart: (courseId, view, length, token, success) => {
        axios.get(`${host}Courses/buildChart?access_token=${token}&courseId=${courseId}&view=${view}&length=${length}`, {
            courseId: courseId,
            view: view,
            length: length
        }).then(res => {
            success(res);
        })
    },
    getThreadMessageCount: (id, token, success) => {
        axios.get(`${host}Threads/${id}/Messages/count?access_token=${token}`)
        .then(res => {
            success(res);
        })
    },
    getCourseAndLectures: (courseId, token, success) => {
        axios.get(`${host}Courses/${courseId}?access_token=${token}`, {
            params: {
                filter: {
                    include: {'CourseSubject': {
                        relation: 'CourseChapter',
                        scope: {
                            order: 'number ASC',
                            include: {
                                relation: 'ChapterVideo',
                                scope: {
                                    order: 'number ASC',
                                
                                where: {or: [{status: 'Active'}, {status: true}]},
                                include: ['VideoFile', 'VideoQuestions']}
                                }
                        }

                    }}
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getSingleCourseUserForProfile: (cuId, token, success) => {
        axios.get(`${host}/CourseUsers/${cuId}?access_token=${token}`, {params: {
            filter: {
                include: 'Course'
            }
        }})
        .then(res => {
            success(res);
        })
    },
    getSingleCourseUser: (profileId, courseId, token, success) => {
        axios.post(`${host}CourseUsers/getSingle?access_token=${token}`, 
            {
                profileId: profileId,
                courseId: courseId,
                include: ['UserTest', {
                    relation: 'UserLecture',
                    scope: {
                        fields: {id: true, completed: true}
                    }
                }]
            
        }).then(res => {
            success(res);
        }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    getAdminCourseUsers: (profileId, token, success) => {
        axios.post(`${host}CourseUsers/getAllAdmin?access_token=${token}`, 
            {
                profileId: profileId,
                include: ['UserTest', {
                    relation: 'UserLecture',
                    scope: {
                        fields: {id: true, completed: true}
                    }
                }]
            
        }).then(res => {
            success(res);
        }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    getCourseUsers: (profileId, token, success) => {
        axios.post(`${host}CourseUsers/getAll?access_token=${token}`, 
            {
                profileId: profileId,
                include: ['UserTest', {
                    relation: 'UserLecture',
                    scope: {
                        fields: {id: true, completed: true}
                    }
                }]
            
        }).then(res => {
            success(res);
        }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    getMoreNotifications: (courseId, created, profileId, skip, token, success) => {
        axios.get(`${host}Courses/${courseId}/Notifications?access_token=${token}`, {
            params: {
                filter: {
                    where: {
                        date: {gte: created},
                        or: [
                            {mine: true, profileId: profileId},
                            {mine: {nlike: true}},
                            {show: true}
                        ]
                    },
                    limit: 20,
                    skip: skip,
                    order: 'id DESC',
                    include: {
                        relation: 'Profile',
                        fields: {
                            image: true,
                            name: true,
                            lname: true
                        }
                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getCourseNotifications: (courseId, created, profileId, token, success) => {
        axios.get(`${host}Courses/${courseId}/Notifications?access_token=${token}`, {
            params: {
                filter: {
                    where: {
                        date: {gte: created},
                        or: [
                            {mine: true, profileId: profileId},
                            {mine: {nlike: true}},
                            {show: true}
                        ]
                    },
                    limit: 6,
                    order: 'id DESC',
                    include: {
                        relation: 'Profile',
                        fields: {
                            image: true,
                            name: true,
                            lname: true
                        }
                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    createCourseNotification: (notification, token, success) => {
        
        if(!notification.createdAt){
            notification.createdAt = new Date();
        }
        axios.post(`${host}CourseNotifications?access_token=${token}`, notification)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    updateSubject: (subject, token, success) => {
        axios.patch(`${host}CourseSubjects/${subject.id}?access_token=${token}`, subject)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    getInstructors: (token, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: ['Course', 'UserTest', {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            },
                            include: {'user': 'Logins'}
                            
                        }],
                where: {
                    role: 'instructor'
                }
            })
        }}).then(res => {
            success(res);
        }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    getSingleUserSubject: (cuId, subjectId, token, success) => {
        axios.get(`${host}Courses/getConsoleUserSubject?access_token=${token}`, {
            params: {
                courseUserId: cuId,
                subjectId: subjectId
            }
        }).then(res => {
            success(res);
        })
    },
    getStudentNotes: (cuId, skip, limit, token, success) => {
        axios.get(`${host}Notes?access_token=${token}`, {
            params: {
                filter: {
                    where: {courseUserId: cuId},
                    skip: skip,
                    limit: limit,
                    order: 'created DESC'
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getStudentSubjects: (courseIds, token, success) => {
        axios.get(`${host}CourseSubjects/?access_token=${token}`, {
            params: {
                filter: {
                    where: {courseId: {inq: courseIds}}
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getStudents: (token, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: ['Course', 'UserTest', {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true, lname: true, email: true, id: true, image: true, smImage: true}
                            },
                            include: {'user': 'Logins'}
                            
                        }],
                where: {
                    role: 'student'
                }
            })
        }}).then(res => {
            success(res);
        })
    },
    getStudentsByCourse: (courseId, token, skip, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: ['Course', 'UserTest', {'user': 'Logins'}, {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            },
                            
                            
                        }],
                where: {
                    role: 'student',
                    courseId: courseId
                },
                limit: 10,
                skip: skip
            })
        }}).then(res => {
            success(res);
        })
    },
    findStudentsByCourse: (where, courseId, token, skip, success) => {
        axios.get(`${host}CourseUsers?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: ['Course', 'UserTest', {'user': 'Logins'}, {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            },
                            
                            
                        }],
                where: where,
                limit: 10,
                skip: skip
            })
        }}).then(res => {
            success(res);
        })
    },
    getStudentCount: (courseId, token, success) => {
        axios.get(`${host}CourseUsers/count?access_token=${token}`, {params: {
            filter: JSON.stringify({
   
                where: {
                    role: 'student',
                    courseId: courseId
                },

            })
        }}).then(res => {
            success(res);
        })
    },
    getCourses: (userId, token, success) => {
        axios.get(`${host}Courses?access_token=${token}`)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },
    getCourseUsersByCourseId: (courseId, token, success) => {
        axios.get(`${host}Courses/${courseId}?access_token=${token}`, {
            params: {
                include: 'CourseUser'
            }
        }).then(res => {
            success(res);
        })
    },
    getPendingRequests: (token, success) => {
        axios.get(`${host}CourseUsers/?access_token=${token}`, {params: {
            filter: {
                where: {status: 'pending'},
                include: ['Profile', 'Course']
            }
        }}).then(res => {
            success(res);
        })
    },
    getSingleCourse: (courseId, token, success) => {
        axios.get(`${host}Courses/${courseId}?access_token=${token}`, {
            params: {
                filter: JSON.stringify(
                    {
                        include: ["DiagnosticTest", "ChapterTestTemplate", 'CourseSubject'],
                        

                    })
            }
        })
        .then(res => {
            success(res);
        })
    },
    getVQ: (id, chapterId, subjectId, token, success) => {
        axios.get(`${host}VideoQuestions/count?access_token=${token}`, {params: {
            where: {
                
                    chapterVideoId: id
                
            }
        }}).then(res => {
            success(res);
        })
    },
    getQQ: (id, chapterId, subjectId, token, success) => {
        axios.get(`${host}QuizQuestions/count?access_token=${token}`, {params: {
            where: {
                
                    chapterVideoId: id
                
            }
        }}).then(res => {
            success(res);
        })
    },
    getSingleSubject: (subjectId, token, success) => {
        axios.get(`${host}CourseSubjects/${subjectId}?access_token=${token}`, {
            params: {
                filter: {
                    include: {
                        relation: 'CourseChapter',
                        scope: {
                            order: 'number ASC',
                            include: {
                                relation: 'ChapterVideo',
                                scope: {
                                    order: 'number ASC',
                                    include: ["ChapterPartImage"]
                                }
                            }
                        }

                    }
                }
            }
        }).then(res => {
            success(res);
        })
    },
    getVideoDiscussion: (chapterVideoId, token, success) => {
        axios.get(`${host}ChapterVideos/${chapterVideoId}/VideoDiscussion?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    include: [{
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }, 'Like','Follow', {'DiscussionComment': {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }}]
                })
            }
        })
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    deleteDiscussion: (id, token, success) => {
        axios.delete(`${host}VideoDiscussions/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    deleteAllDiscussions: (chapterVideoId, token, success) => {
        axios.delete(`${host}ChapterVideos/${chapterVideoId}/VideoDiscussion?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    deleteComment: (id, token, success) => {
        axios.delete(`${host}DiscussionComments/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    updateUserLecture: (ul, token, success) => {
        delete ul.active;
        axios.patch(`${host}UserLectures/${ul.id}?access_token=${token}`, ul, {params: {
            filter: JSON.stringify({
                include: ['UserChapter','VideoQuestions', 'Quiz', {
                    relation: 'Lecture',
                    scope: {
                        include: ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions",  {
                            relation: 'QuizQuestions',
                            scope: {
                              order: 'number ASC',
                              include: 'File'
                            }}, 'VideoFile', {'VideoDiscussion': [{
                          relation: 'Profile',
                              scope: {
                                  fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                              }
                              
                          }, 'Like','Follow', {'DiscussionComment': {
                          relation: 'Profile',
                          scope: {
                              fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                          }
                          
                      }}]}]
                    }
                }]
            })
        }})
        .then(res => {
            success(res);
        });
    },
    getUserLecture: (videoId, profileId, token, success) => {
        axios.get(`${host}UserLectures/getOrMake?access_token=${token}&videoId=${videoId}&profileId=${profileId}`)
        .then(res => {
            success(res);
        });
    },
    getUserLectureOlder: (id, courseUserId, subjectAttempt, userSubject, token, success) => {
        axios.get(`${host}UserLectures`, {
            params: {
                filter: JSON.stringify({
                    where: {
                        chapterVideoId: id,
                        courseUserId: courseUserId,
                        userSubjectId: userSubject.id,
                        active: true
                    },
                    include: ['UserChapter','VideoQuestions', 'Quiz', {
                        relation: 'Lecture',
                        scope: {
                            include: ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions",  {
                                relation: 'QuizQuestions',
                                scope: {
                                  order: 'number ASC',
                                  include: 'File'
                                }}, 'VideoFile', {'VideoDiscussion': [{
                              relation: 'Profile',
                                  scope: {
                                      fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                                  }
                                  
                              }, 'Like','Follow', {'DiscussionComment': {
                              relation: 'Profile',
                              scope: {
                                  fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                              }
                              
                          }}]}]
                        }
                    }]
                })
            }
        }).then(res => {
            success(res);
        })
    },
    createUserChapter: (chapterId, courseUserId, profileId, userId, userSubjectId, token, success) => {
        axios.post(`${host}UserChapters?access_token=${token}`, {
            subjectChapterId: chapterId,
            courseUserId: courseUserId,
            profileId: profileId,
            userId: userId,
            userSubjectId: userSubjectId,
            progress: 0,
            created: new Date(),
            name: ''
        }).then(res => {
            success(res);
        });
    },
    createUserLecture: (id, courseUserId, subjectAttempt, courseAttempt, userSubject, token, success) => {
        axios.post(`${host}UserLectures/createLecture`, {
            lecture: {
                chapterVideoId: id,
                courseUserId: courseUserId,
                attempts: 1,
                subjectAttempt: subjectAttempt,
                userSubjectId: userSubject.id,
                courseAttempt: courseAttempt,
                title: '',
                attentiveness: 0,
                efficiency: 0,
                createdOn: new Date(),
                duration: 0,
                currentTime: 0,
                userTime: 0,
                completed: false,
                active: true,
                quiz: 0,
                completion: 0,
                totalPoints: 0,
                points: [],
                maxTime: 0
    
            },
            params: {
                
                filter: JSON.stringify({
                    where: {
                        chapterVideoId: id,
                        courseUserId: courseUserId,
                        subjectAttempt: subjectAttempt
                    },
                    include: {
                        relation: 'Lecture',
                        scope: {
                            include: ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions",  {
                                relation: 'QuizQuestions',
                                scope: {
                                  order: 'number ASC',
                                  include: 'File'
                                }}, 'VideoFile', {'VideoDiscussion': [{
                              relation: 'Profile',
                                  scope: {
                                      fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                                  }
                                  
                              }, 'Like','Follow', {'DiscussionComment': {
                              relation: 'Profile',
                              scope: {
                                  fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                              }
                              
                          }}]}]
                        }
                    }
                })
            }
        }).then(res => {
            success(res);
        })
    },
    getUserChapterPart: (id, token, success) => {
        axios.get(`${host}ChapterVideos/${id}?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    include: ["ChapterPartImage", "ChapterPartBanner", "VideoQuestions",  {
                              relation: 'QuizQuestions',
                              scope: {
                                order: 'number ASC',
                                include: 'File'
                              }}, 'VideoFile', {'VideoDiscussion': [{
                            relation: 'Profile',
                                scope: {
                                    fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                                }
                                
                            }, 'Like','Follow', {'DiscussionComment': {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }}]}]
                })
            }
        })
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },

    deleteVideo: (video, token, success) => {
        axios.delete(`${host}VideoFiles/${video.id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    getUserChapterPartTest: (chapterPartId, userId, token, success) => {
        axios.get(`${host}ChapterTests?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    where: {
                        chapterVideoId: chapterPartId,
                        userId: userId
                    }
                })
            }
        })
            .then(res => {
                success(res);
            })
    },
    scoreUserChapterPartTest: (test, token, success) => {
        axios.post(`${host}ChapterTests/scoreTestWithoutQuestion?access_token=${token}`, {id: test})
            .then(res => {
                success(res);
            })
    },
    fakeScoreUserChapterPartTest: (test, token, success) => {
        axios.post(`${host}ChapterTests?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },

    addUserVideoQuestion: (question, token, success) => {
        axios.post(`${host}UserVideoQuestions?access_token=${token}`, question)
            .then(res => {
                success(res);
            })
    },
    updateUserVideoQuestion: (question, token, success) => {
        axios.patch(`${host}UserVideoQuestions/${question.id}?access_token=${token}`, question)
            .then(res => {
                success(res);
            })
    },
    updateOfficialTest: (test, token, success) => {
        
        axios.patch(`${host}OfficialTests/${test.id}?access_token=${token}`, test, {params: {
            filter: {
                include: 'Course'
            }
        }})
            .then(res => {
                success(res);
            })
    },
    deleteOfficialTest: (testId, token, success) => {
        axios.delete(`${host}OfficialTests/${test.id}?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    addOfficialTest: (test, token, success) => {
        
        axios.post(`${host}OfficialTests?access_token=${token}`, test, {params: {
            filter: {
                include: 'Course'
            }
        }})
            .then(res => {
                success(res);
            })
    },
    getOfficialTests: (profileId, token, success) => {
        axios.get(`${host}OfficialTests?access_token=${token}`, {params: {
            filter: {
                where: {profileId: profileId},
                include: 'Course'
            }
        }})
            .then(res => {
                success(res);
            })
    },
    getUserVideoQuestions: (chapterVideoId, profileId, token, success) => {
        axios.get(`${host}UserVideoQuestions?access_token=${token}`, {params: {
            filter: JSON.stringify({
                where: {
                    profileId: profileId,
                    chapterVideoId: chapterVideoId
                }
            })
        }})
            .then(res => {
                success(res);
            })
    },
    postDiscussion: (comment, user, token, success) => {
        axios.post(`${host}VideoDiscussions?access_token=${token}`, comment, {params: {
            filter: JSON.stringify({
                include: [{
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }, 'DiscussionComment', 'Like', 'Follow']
            })
        }})
            .then(res => {

                axios.get(`${host}VideoDiscussions/${res.data.id}?access_token=${token}`, {params: {
                    filter: JSON.stringify({
                        include: [{
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }, 'DiscussionComment', 'Like','Follow']
                    })
                }}).then(r2 => {
                    success(r2);
                })

            })
    },
    postLike: (like, token, success) => {
        axios.post(`${host}Likes?access_token=${token}`, like)
            .then(res => {
                success(res);
            })
    },
    deleteLike: (like, token, success) => {
        axios.delete(`${host}Likes/${like.id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    postComment: (comment, user, token, success) => {
        axios.post(`${host}DiscussionComments?access_token=${token}`, comment, {params: {
            filter: JSON.stringify({
                include: {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }
            })
        }})
            .then(res => {
                axios.get(`${host}DiscussionComments/${res.data.id}?access_token=${token}`, {params: {
                    filter: JSON.stringify({
                        include: {
                            relation: 'Profile',
                            scope: {
                                fields: {name: true,lname: true, email: true, id: true,image: true, smImage: true}
                            }
                            
                        }
                    })
                }}).then(r2 => {
                    success(r2);
                })
            })
    },
    updateQuestionNumbers: (questions, token, success) => {
          axios.post(`${host}QuizQuestions/renumber?access_token=${token}`, {questions: questions, access_token: token})
          .then(res => {
              success(res);
          })
    },
    sendFeedback: (feedback, token, success) => {
        axios.post(`${host}Feedbacks/?access_token=${token}`, feedback)
          .then(res => {
              success(res);
          }) 
    },
    getUserCourse: (courseId, token, success) => {
        axios.get(`${host}Courses?access_token=${token}`, {
            params: {
                filter:
                    JSON.stringify(
                        {
                            include: ["DiagnosticTest", {"CourseSubject": {"CourseChapter": {"ChapterVideo": ["ChapterPartBanner", "ChapterPartImage", "VideoQuestions",  {
                              relation: 'QuizQuestions',
                              scope: {
                                order: 'number ASC',
                                include: 'File'
                              }}]}}}],
                            where:
                                {
                                    id: courseId
                                }

                        })
            }
        })
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },
    addCourseUser: (courseUser, token, success) => {
        axios.post(`${host}CourseUsers/addCourseUser?access_token=${token}`, {user: courseUser}, {params: {
            filter: JSON.stringify({
                include: "Profile"
            })
        }})
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    removeCourseUser: (id, token, success) => {
        axios.delete(`${host}CourseUsers/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    deleteUserVideoQuestions: (videoId, profileId, token, success) => {
        // delete where video + profileId
        axios.post(`${host}UserVideoQuestions/update?access_token=${token}`, {complete: false}, {params: {

                where: JSON.stringify({
                    profileId: profileId,
                    chapterVideoId: videoId
                })

        }}).then(res => {
            success(res);
        })
    },
    deleteChapterTests: (testId, profileId, token, success) => {
      axios.delete(`${host}Profiles/${profileId}/ChapterTest/${testId}?access_token=${token}`)  
      .then(res => {
          success(res);
      })
    },
    approveCourseUserRequest: (id, token, success) => {
      axios.patch(`${host}CourseUsers/${id}?access_token=${token}`, {status: "approved"}, {params: {filter: JSON.stringify({include: "Profile"})}})
          .then(res => {
              success(res);
          }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    addCourseSubject: (data, id, token, success) => {
        let d = {
            subject: data,
            courseId: id
        }
        axios.post(`${host}/CourseSubjects/addSubject?access_token=${token}`, d)
        .then(res => {
            success(res);
        })

        /*
      axios.post(`${host}Courses/${id}/CourseSubject?access_token=${token}`, data)
          .then(res => {
              success(res);
          }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
        */
    },
    updateCourseSubject: (data, token, success) => {
      let subjectId = data.id;
      axios.patch(`${host}CourseSubjects/${subjectId}?access_token=${token}`, data)
          .then(res => {
              success(res);
          }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },
    updateCourse: (course, userId, token, success) => {
        axios.patch(`${host}Courses?access_token=${token}`, course, {
            params: {
                filter:
                    JSON.stringify(
                        {
                            include: {"CourseSubject": {"CourseChapter": {"ChapterVideo": ['VideoFile', 'VideoQuestions', 'ChapterPartBanner', 'ChapterPartImage',  {
                              relation: 'QuizQuestions',
                              scope: {
                                order: 'number ASC',
                                include: 'File'
                              }}]}}},
                            where:
                                {
                                    owner: userId
                                }

                        })
            }
        })
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    deleteCourse: (id, token, success) => {
      axios.delete(`${host}Courses/${id}?access_token=${token}`)
          .then(res => {
              success(res);
          })
    },
    deleteSubject: (id, token, success) => {
        let d = {
            subjectId: id
        }
        axios.post(`${host}CourseSubjects/removeSubject?access_token=${token}`, d)
            .then(res => {
                success(res)
            })
    },
    getCourseSubjects: (courseId, token, success) => {
        axios.get(`${host}CourseSubjects?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    where: {
                        courseId: courseId
                    }
                })
            }
        })
            .then(res => {
                success(res);
            });
    },
    addSubjectChapter: (data, courseId, subjectId, token, success) => {
        data.courseId = courseId;
        axios.post(`${host}CourseSubjects/${subjectId}/CourseChapter?access_token=${token}`, data)
            .then(res => {
                success(res);
            })
    },

    reorderChapters: (data, token, success) => {
        data.map(d => {
            axios.patch(`${host}SubjectChapters/${d.id}?access_token=${token}`, {number: d.number})
                .then(res => {
                    success(res);
                })
        })
    },
    reorderChapterParts: (data, token, success) => {
        data.map(d => {
            axios.patch(`${host}ChapterVideos/${d.id}?access_token=${token}`, {number: d.number})
                .then(res => {
                    success(res);
                })
        })

    },
    editSubjectChapter: (data, courseId, subjectId, token, success) => {
        axios.patch(`${host}SubjectChapters/?access_token=${token}`, data)
            .then(res => {
                success(res);
            })
    },
    getSubjectChapters: (subjectId, token, success) => {
        axios.get(`${host}SubjectChapters?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    where: {
                        subjectId: subjectId
                    }
                })
            }
        }).then(res => {

            success(res);
        })
    },
    addChapterVideo: (chapterPart, chapterId, token, success) => {
        axios.post(`${host}SubjectChapters/${chapterId}/ChapterVideo?access_token=${token}`, chapterPart)
            .then(res => {
                success(res);
            });
    },
    updateChapterPart: (data, id, token, success) => {
        axios.patch(`${host}ChapterVideos/${id}?access_token=${token}`, data, {
            params: {
                filter: JSON.stringify({
                    include: 'VideoFile'
                })
            }
        })
            .then(res => {
                success(res);
            })
    },
    getChapterVideo: (id, token, success) => {
        axios.get(`${host}/ChapterVideos/${id}?access_token=${token}`, {
            params: {
                filter: JSON.stringify({
                    include: ['VideoFile', 'VideoQuestions', 'ChapterPartBanner', 'ChapterPartImage',  {
                              relation: 'QuizQuestions',
                              scope: {
                                order: 'number ASC',
                                include: 'File'
                              }}]
                })
            }
        })
            .then(res => {
                success(res);
            })
    },
    deleteChapterPartVideoFile: (id, token, success) => {
        axios.delete(`${host}ChapterVideos/${id}/VideoFile?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    updateChapterPartIdOfVideo: (video, chapterPartId, token, success) => {
      axios.patch(`${host}VideoFiles/${video.id}?access_token=${token}`, {chapterVideoId: chapterPartId})
          .then(res => {
              success(res);
          })
    },
    addChapterPartIdOfVideo: (video, chapterPartId, token, success) => {
        axios.patch(`${host}VideoFiles/${video.id}?access_token=${token}`, {chapterVideoId: chapterPartId})
            .then(res => {
                success(res);
            })
    },
    uploadSubtitles: (file, videoId, token, success) => {
        axios.post(`${host}VideoFiles/uploadSubtitles?videoId=${videoId}`, file)
            .then(res => {
                success(res);
            });
    },
    uploadAvatar: (file, profileId, token, success) => {
        axios.post(`${host}VideoFiles/uploadAvatar?profileId=${profileId}`, file)
            .then(res => {
                success(res);
            });
    },
    uploadTestFile: (file, profileId, token, success) => {
        axios.post(`${host}VideoFiles/uploadTestFile?profileId=${profileId}`, file)
            .then(res => {
                success(res);
            });
    },
    uploadVideoFile: (file, chapterPartId, duration, token, success, onProgress) => {

        let config = {
            onUploadProgress: progressEvent => {
                let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                return onProgress(percentCompleted);
                // do whatever you like with the percentage complete
                // maybe dispatch an action that will update a progress bar or something
            }
        }

        axios.post(`${host}VideoFiles/upload?chapterVideoId=${chapterPartId}&duration=${duration}`, file, config)
            .then(res => {
                success(res);
            });
    },
    uploadChapterFile: (file, chapterId, token, success) => {

        const data = new FormData();
        data.append('file', file, new Date().getTime().toString() + "-" + file.name);

        axios.post(`${host}VideoFiles/uploadChapterFile?chapterId=${chapterId}`, data)
            .then(res => {
                success(res);
            });
    },
    
    uploadMessageFiles: (files, profileId, token, success) => {
        const data = new FormData();
        
        for(let i = 0; i < files.length; i++){
        
            data.append('file', files[i], new Date().getTime().toString() + "-" + files[i].name);    
        }
        

        axios.post(`${host}MessageFiles/uploadMessageFile?profileId=${profileId}`, data)
            .then(res => {
                success(res);
            });
    },
    
    deleteMessageFile: (file, profileId, token, success) => {
        axios.delete(`${host}MessageFiles/${file.id}`)
        .then(res => {
            success(res);
        })
    },

    uploadQuestionFile: (file, questionId, token, success) => {

        const data = new FormData();
        data.append('file', file, new Date().getTime().toString() + "-" + file.name);

        axios.post(`${host}VideoFiles/uploadQuestionFile?quizQuestionId=${questionId}`, data)
            .then(res => {
                success(res);
            });
    },
    deleteChapterFile: (id, token, success) => {
        axios.delete(`${host}VideoFiles/${id}?access_token=${token}`)
            .then(res => {
                success(res)
            })
    },
    deleteQuestionFile: (id, token, success) => {
        axios.delete(`${host}VideoFiles/${id}?access_token=${token}`)
            .then(res => {
                success(res)
            })
    },
    getQuizQuestion: (id, token, success) => {
        axios.get(`${host}QuizQuestions/${id}?access_token=${token}`, {params: {
            filter: JSON.stringify({
                include: 'File'
            })
        }}).then(res => {
            success(res);
        })
    },
    uploadChapterPartImage: (file, chapterPartId, token, success) => {
        axios.post(`${host}ChapterPartImages/upload?chapterVideoId=${chapterPartId}`, file)
            .then(res => {
                success(res);
            })
    },
    uploadChapterPartBanner: (file, chapterPartId, token, success) => {
        axios.post(`${host}ChapterPartBanners/upload?chapterVideoId=${chapterPartId}`, file)
            .then(res => {
                success(res);
            })
    },
    updateVideoFileChapterPartId: (chapterPartId, videoId, token, success) => {
        axios.patch(`${host}VideoFile/${videoId}?access_token=${token}`, {chapterVideoId: chapterPartId})
            .then(res => {
                success(res);
            })
            .onUploadProgress(res => {
                // Nothing
            })
    },
    loadVideoById: (id, token, success) => {
        axios.get(`${host}VideoFiles/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        });
    },
    removeChapterPart: (id, token, success) => {
        axios.delete(`${host}ChapterVideos/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            });
    },
    deleteChapter: (id, token, success) => {
        axios.delete(`${host}SubjectChapters/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            });
    },
    addVideoQuestion: (question, chapterPartId, token, success) => {
        axios.post(`${host}ChapterVideos/${chapterPartId}/VideoQuestions?access_token=${token}`, question)
            .then(res => {
                success(res);
            })
    },
    addQuizQuestion: (question, chapterPartId, token, success) => {
        axios.post(`${host}ChapterVideos/${chapterPartId}/QuizQuestions?access_token=${token}`, question)
            .then(res => {
              success(res);
            })
    },
    deleteQuizQuestion: (id, token, success) => {
        axios.delete(`${host}QuizQuestions/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    deleteVideoQuestion: (id, token, success) => {
        axios.delete(`${host}VideoQuestions/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    updateQuizQuestion: (id, question, token, success) => {
        axios.patch(`${host}QuizQuestions/${id}?access_token=${token}`, question)
            .then(res => {
                success(res);
            })
    },
    uploadAudio: (data, token, success) => {
        axios.post(`${host}QuestionAudios/upload?chapterVideoId=5ac2399b535bc914983098a4?access_token=${token}`, data)
            .then(res => {
                success(res);
            });
    },
    getTestsByUID: (uid, token, success) => {
        axios.get(`${host}users/${uid}/DiagnosticTest?access_token=${token}`)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    addTest: (data, token, success) => {
        data.userId = data.owner;
        axios.post(`${host}DiagnosticTests?access_token=${token}`, data)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    updateVideoQuestion: (question, token, success) => {
        axios.patch(`${host}VideoQuestions/${question.id}?access_token=${token}`, question)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    updateTest: (data, token, success) => {
        axios.patch(`${host}DiagnosticTests?access_token=${token}`, data)
            .then(res => {
                success(res);
            }).catch(error => {
            if(error.toString() == "Error: Request failed with status code 401"){
                logoutUserAction();
                window.localStorage.clear();
                window.location.href = "/login";
            }
            
        })
    },
    deleteTest: (id, token, success) => {
        axios.delete(`${host}DiagnosticTests/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },
    deleteCourseTest: (id, token, success) => {
        axios.delete(`${host}ChapterVideos/${id}?access_token=${token}`)
            .then(res => {
                success(res);
            })
    },

    /**********************************************************************
     * Tests
     */

    getUserTestCopy: (id, pid, token, success) => {
        axios.post(`${host}UserTests/copyTest?access_token=${token}`, {testId: id, profileId: pid})
            .then(res => {
                success(res)
            })
    },
    getSubjectTestCopy: (id, pid, token, success) => {
        axios.post(`${host}UserTests/copySubjectTest?access_token=${token}`, {testId: id, profileId: pid})
            .then(res => {
                success(res)
            })
    },
    updateUserTest: (test, token, success) => {
        axios.patch(`${host}UserTests/${test.id}?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    scoreTest: (testId, token, success) => {
        axios.post(`${host}UserTests/scoreTest?access_token=${token}`, {userTestId: testId})
            .then(res => {
                success(res);
            })
    },
    updateSubjectTest: (test, token, success) => {
        axios.patch(`${host}UserLectures/${test.id}?access_token=${token}`, test)
            .then(res => {
                success(res);
            })
    },
    scoreSubjectTest: (testId, token, success) => {
        axios.post(`${host}UserLectures/scoreSubjectTest?access_token=${token}`, {userTestId: testId})
            .then(res => {
                success(res);
            })
    },
    createEvent: (event, userId, token, success) => {
        event.allDay = false;
        event.start = event.start.toDate();
        axios.post(`${host}users/${userId}/Events?access_token=${token}`, event)
            .then(res => {
                success(res);
            })
    },
    getEvents: (userId, token, success) => {
        axios.get(`${host}users/${userId}/Events?access_token=${token}`)
            .then(res => {
                success(res);
            });
    },
    createCourseUser: (courseUser, token, success) => {
        axios.post(`${host}CourseUsers/addOne?access_token=${token}`, {cu: courseUser})
            .then(res => {
                success(res);
            })
    },
    syncStudentsSubjectOrders: (courseId, token, success) => {
        axios.post(`${host}CourseUsers/syncAllSubjectOrders?access_token=${token}`, {
            courseId: courseId
        }).then(res => {
            success(res);
        })
    },
    sendStat: (stat, token, success) => {
        axios.post(`${host}Stats/addRemote?access_token=${token}`, {stat})

            .then(res => {
                success(res);
            })
    },
    messengerSearch: (term, token, success) => {
        axios.post(`${host}Profiles/search?access_token=${token}`, {term: term})
            .then(res => {
                success(res);
            })
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js